import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import classnames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import { GRADIENTS } from '../../../utils/constants'
import styles from './styles'
import { TableBody } from 'material-ui'

const getpath = props => {
  const { link } = props;
  const type = link.document[0].__typename || null;
  const service = link.document[0].data.service_type || null;
  return type === "PrismicCtServiceFocus" ? `/service/${service}/` : '/shot/' 
}

const Lister = withStyles(styles)(props => {
  const { contents, type, inc, count, classes, key } = props
  const data = contents.filter(x => x.type === type)[count[type]].content

  inc(type)
  return (
    data && (
      <div className={classes.page} key={key}>
        <div className={classes.contents}>
          <div className={classes.lister}>
            <div className={classnames(classes.layout, classes.margins)}>
              <div className={classes.list}>
                {data.primary.step && (
                  <Typography variant="title">
                    {data.primary.step.text}
                  </Typography>
                )}
                <Typography variant="headline">
                  {data.primary.title.text}
                </Typography>
                <Typography variant="subheading">
                  {data.primary.subtitle1.text}
                </Typography>

                <Grid container spacing={0} className={classes.listerItems}>
                  {data.items.map((item, key) => {

                    let path = getpath(item);

                    return (
                      <Grid
                        item
                        xs={12}
                        className={classes.listerItem}
                        key={key}
                      >
                        <Grid container spacing={0}>
                          <Grid item xs={9}>
                            <Typography variant="caption">
                              {item.title.text}
                            </Typography>
                            <Typography>{item.lead1.text}</Typography>
                            <div className={classes.listerLink}>
                              <Link
                                to={`${path}${item.link.document[0].uid}`}
                                className={classes.linkText}
                              >
                                Find out more
                              </Link>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            className={classes.listerImageContainer}
                          >
                            {item.image.localFile && (
                              <Img
                                sizes={
                                  item.image.localFile.childImageSharp.sizes
                                }
                                className={classes.listerImage}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
})

export default withStyles(styles)(Lister)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/lister.js